import { gql } from '@apollo/client';
import { CbAccountBalanceFields } from './fragments';

export const ADMIN_ADJUST_CB_BALANCE = gql`
  mutation AdminAdjustCbBalance($input: AdminAdjustCbBalanceInput!) {
    adminAdjustCbBalance(input: $input) {
      ...CbAccountBalanceFields
    }
  }
  ${CbAccountBalanceFields}
`;

export const ADMIN_SET_CB_BALANCE_NEGATIVE_ALLOWED = gql`
  mutation AdminSetCbBalanceNegativeAllowed(
    $input: AdminSetCbBalanceNegativeAllowedInput!
  ) {
    adminSetCbBalanceNegativeAllowed(input: $input)
  }
`;

export const ADMIN_FUND_CAMPAIGN_FROM_BALANCE = gql`
  mutation AdminFundCampaignFromBalance(
    $input: AdminFundCampaignFromBalanceInput!
  ) {
    adminFundCampaignFromBalance(input: $input) {
      ...CbAccountBalanceFields
    }
  }
  ${CbAccountBalanceFields}
`;

export const ADMIN_RETURN_CAMPAIGN_BUDGET_TO_BALANCE = gql`
  mutation AdminReturnCampaignBudgetToBalance(
    $input: AdminReturnCampaignBudgetInput!
  ) {
    adminReturnCampaignBudgetToBalance(input: $input) {
      ...CbAccountBalanceFields
    }
  }
  ${CbAccountBalanceFields}
`;
